module.exports = __webpack_public_path__ + "img/2.1be395ab.png";